export enum BillsTableActionType {
  CreateCreditNote = 'createCreditNote',
  Duplicate = 'duplicate',
  Edit = 'edit',
  RegisterPayment = 'registerPayment',
  Void = 'void',
  VoidPayment = 'voidPayment',
}
